<template>
  <v-dialog max-width="600" v-model="errorDialog" style="z-index: 999">
    <v-card>
      <v-toolbar dark color="error">
        <v-toolbar-title>Error</v-toolbar-title>
        <v-spacer></v-spacer>
          <v-btn icon dark @click="closeErrorPopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-toolbar>
      <v-card-text class="pa-4">
        <p v-for="(msg, idx) in getErrorMsg" :key="`error_msg_${idx}`">{{msg}}</p>
      </v-card-text>
      <v-card-actions class="blue-grey lighten-5 justify-end">
        <v-btn color="error" class="white--text" @click="closeErrorPopup">
          {{ $t('label.check') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import envs from '@/envs'
import store from '@/store'
export default {
  name: 'ErrorDialog',
  computed: {
    getErrorMsg() {
      if (envs.framework.useErrorList) {
        return store.state.error.msgList
      }
      let summary = store.state.error.summary
      let sList = []
      for (let s in summary) {
        sList.push(`${s}: ${summary[s]}`)
      }
      let msg = _.last(store.state.error.msgList)
      if (sList.length > 0) {
        msg = msg + ` (${sList.join(', ')})`
      }
      return [msg]
    },
    errorDialog: {
      get() {
        return store.state.error.showConfirm
      },
      set(val) {
        store.commit('SET_SHOW_CONFIRM', val)
      }
    }
  },
  methods: {
    closeErrorPopup() {
      store.dispatch('CloseErrorConfirm')
    }
  }
}
</script>

<style lang="scss">
</style>
